<template>
    <b-modal id="facility_other" ref="facility_other" @hidden="resetModal"
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            <div v-if="mode === 'status'">
                Update Status for<br>
                <div class="text-primary"> {{ facility.data.attributes.name }}</div>
            </div>

            <div v-if="mode === 'comment' && !edit">
                Add comment for<br>
                <div class="text-primary"> {{ facility.data.attributes.name }}</div>
            </div>

            <div v-if="mode === 'comment' && edit">
                Edit comment for<br>
                <div class="text-primary"> {{ facility.data.attributes.name }}</div>
            </div>

            <div v-if="mode === 'contract' && !edit">
                Add contract for<br>
                <div class="text-primary"> {{ facility.data.attributes.name }}</div>
            </div>

            <div v-if="mode === 'contract' && edit">
                Edit contract for<br>
                <div class="text-primary"> {{ facility.data.attributes.name }}</div>
            </div>
        </template>

        <div v-if="mode === 'status'" class="d-flex flex-row mb-4">
            <span class="iconsminds-power-2 mr-3 menu-icon-style"/>

            <p class="my-auto">Status lorem You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the facility!
            </p>
        </div>

        <div v-if="mode === 'comment'" class="d-flex flex-row mb-4">
            <span class="iconsminds-speach-bubbles mr-3 menu-icon-style"/>

            <p class="my-auto">Comment lorem You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the facility!
            </p>
        </div>

        <div v-if="mode === 'contract'" class="d-flex flex-row mb-4">
            <span class="iconsminds-speach-bubbles mr-3 menu-icon-style"/>

            <p class="my-auto">Contract lorem You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the facility!
            </p>
        </div>

        <b-form>
            <b-row v-if="validationError" class="mb-2">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <template v-if="mode === 'status' || mode === 'comment'">
                <b-row v-if="mode === 'status'">
                    <b-colxx v-if="form.status" xxs="12" class="mb-4">
                        <h6>
                            <b-badge class="w-100" :variant="'outline-' + facilityStatusColor(form.status)">
                                The Facility will be {{ form.status.toUpperCase() }} after submission!
                            </b-badge>
                        </h6>
                    </b-colxx>

                    <b-colxx md="12" class="mb-2">
                        <b-form-group label="Type" class="has-float-label">
                            <template v-slot:label>
                                <span>Change Status <sup><code>*</code></sup></span>
                            </template>

                            <v-select @input="updateStatus" v-model="selected.status" :options="status"
                                      :border-danger="'type' in errors"/>

                            <b-form-invalid-feedback :state="!'type' in errors"
                                                     v-text="'type' in errors ? errors.type[0] : ''"/>
                        </b-form-group>
                    </b-colxx>
                </b-row>

                <b-row>
                    <b-colxx md="12">
                        <b-form-group label="Comment" class="has-float-label">
                            <template v-slot:label>
                                <span>Comment <sup><code>*</code></sup></span>
                            </template>

                            <b-form-textarea v-model="form.comment" rows="6"
                                             @input="'comment' in errors ? (delete errors.comment) : ''"
                                             placeholder="Comment"/>

                            <b-form-invalid-feedback :state="!('comment' in errors)"
                                                     v-text="'comment' in errors ? errors.comment[0] : ''"/>
                        </b-form-group>
                    </b-colxx>
                </b-row>
            </template>

            <template v-if="mode === 'contract'">
                <b-row>
                    <b-colxx md="12">
                        <b-form-group label="Contract From" class="has-float-label">
                            <template v-slot:label>
                                <span>Contract From <sup><code>*</code></sup></span>
                            </template>

                            <v-date-picker
                                popover-visibility="focus" mode="single"
                                v-model="datepicker.from"
                                @input="'from' in errors ? delete errors.from : ''"
                                :input-props="{ class:'form-control' + ('from' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                            <b-form-invalid-feedback :state="!'from' in errors"
                                                     v-text="'from' in errors ? errors.from[0] : ''"/>
                        </b-form-group>
                    </b-colxx>
                </b-row>

                <b-row>
                    <b-colxx md="12">
                        <b-form-group label="Contract To" class="has-float-label">
                            <template v-slot:label>
                                <span>Contract To <sup><code>*</code></sup></span>
                            </template>

                            <v-date-picker
                                popover-visibility="focus" mode="single"
                                v-model="datepicker.to"
                                @input="'to' in errors ? delete errors.to : ''"
                                :input-props="{ class:'form-control' + ('to' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                            <b-form-invalid-feedback :state="!'to' in errors"
                                                     v-text="'to' in errors ? errors.to[0] : ''"/>
                        </b-form-group>
                    </b-colxx>
                </b-row>

                <b-row>
                    <b-colxx md="12">
                        <b-form-group label="Notes" class="has-float-label">
                            <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                        </b-form-group>
                    </b-colxx>
                </b-row>

                <b-row>
                    <b-colxx md="12">
                        <vue-dropzone ref="fileDropZone" id="dropzone"
                                      @vdropzone-error="attachmentError"
                                      :destroy-dropzone="false" :options="dropzoneOptions"/>
                    </b-colxx>
                </b-row>

                <b-row v-if="edit && mode === 'contract'" class="mt-4">
                    <b-colxx md="12">
                        <FilesList v-if="form.attachments" :edit="true" :files="form.attachments.data" @delete="deleteFile"/>
                    </b-colxx>
                </b-row>
            </template>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('facility_other')" v-text="'Cancel'"/>

            <template v-if="mode === 'status' && currentStatus === form.status">
                <b-button variant="primary" v-if="!edit && (mode === 'status' || mode === 'comment')" disabled
                          v-text="'Submit'"/>
            </template>

            <template v-else>
                <state-button variant="primary"
                              v-if="!edit && (mode === 'status' || mode === 'comment' || mode === 'contract')"
                              :click="submitFacilityOther">
                    Submit
                </state-button>
            </template>

            <state-button variant="primary" v-if="edit && mode ==='comment'" :click="updateFacilityComment">Update
            </state-button>

            <state-button variant="primary" v-if="edit && mode ==='contract'" :click="updateFacilityContract">Update
            </state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import Switches from 'vue-switches';
import StateButton from "../../../../../components/Common/StateButton";
import moment from "moment";
import VueDropzone from 'vue2-dropzone';
import FilesList from "../../../../../components/Listing/FilesList";

export default {
    name: "FacilityOtherModal",

    components: {
        FilesList,
        Switches,
        StateButton,
        VueDropzone
    },

    props: [
        'facility', 'mode', 'edit', 'currentStatus'
    ],

    data() {
        return {
            status: [
                {label: 'Active', value: 'Active'},
                {label: 'Inactive', value: 'Inactive'},
                {label: 'Offline', value: 'Offline'},
            ],
            datepicker: {
                from: null,
                to: null,
            },
            selected: {
                status: [],
            },
            validationError: null,
            deleted_attachments: [],
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload files.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    mounted() {
        this.selected.status = [
            {
                label: this.facility.data.attributes.status,
                value: this.facility.data.attributes.status,
            }
        ];
    },

    watch: {
        facility() {
            this.selected.status = [
                {
                    label: this.facility.data.attributes.status,
                    value: this.facility.data.attributes.status,
                }
            ];
        },

        form() {
            if (this.edit && this.mode === 'contract') {
                this.datepicker.from = moment(this.form.from).toDate();
                this.datepicker.to = moment(this.form.to).toDate();
            }
        },

        'datepicker.from'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.from = null;
            this.form.from = moment(date).format('YYYY-MM-DD');
        },
        'datepicker.to'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.to = null;
            this.form.to = moment(date).format('YYYY-MM-DD');
        },
    },

    computed: {
        ...mapGetters({
            form: 'getFacilityOtherForm',
            errors: 'getFacilityErrors',
        }),
    },

    methods: {
        submitFacilityOther() {
            return new Promise((success, fail) => {
                if (this.mode === 'status') this.$store.dispatch('submitFacilityStatus', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            let newStatus = response.data.data.attributes.status;

                            this.$emit('updated', newStatus);

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'Status updated!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('facility_other');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
                else if (this.mode === 'comment') this.$store.dispatch('submitFacilityComment', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'New comment added!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('facility_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
                else if (this.mode === 'contract') this.$store.dispatch('submitFacilityContract', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'New contract added!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('facility_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            });
        },

        updateFacilityComment() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateFacilityComment', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'Comment Updated!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('facility_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            });
        },

        updateFacilityContract() {
            let payload = {
                ...this.form,
                deleted_attachments: this.deleted_attachments,
            };
            return new Promise((success, fail) => {
                this.$store.dispatch('updateFacilityContract', payload)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'Contract Updated!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('facility_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            });
        },

        deleteFile(file) {
            this.deleted_attachments.unshift(file);
            this.form.attachments.data.splice(file.index, 1);
        },

        updateStatus(field) {
            if (field) {
                this.form.status = field.value;
            } else {
                this.form.status = '';
            }
            'status' in this.errors ? delete this.errors.status : '';
        },

        resetModal() {
            this.$emit('close');
            this.$store.commit('setFacilityOtherForm');
            this.datepicker = {
                from: null,
                to: null,
            };
            this.validationError = null;
            this.deleted_attachments = [];
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        facilityStatusColor: status => {
            if (status === 'Active') return 'info'
            else if (status === 'Inactive') return 'danger'
            else if (status === 'Offline') return 'warning'
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        uploadFiles(contract) {
            console.log(contract);
            let url = '/api/hms/locations/facilities/' + this.facility.facility_id + '/contracts/' + contract.contract_id + '/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(contract);
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },
    },
}
</script>

<style scoped>

</style>
